import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import ErrorBoundary from './ErrorBoundary';
import { SIDEBAR_WIDTH_PX } from '../constants/layout';

export default function Layout() {
  return (
    <div className="min-h-screen flex">
      {/* サイドバー */}
      <Sidebar />

      {/* メインコンテンツエリア（左マージンはサイドバー幅と同じ定数を参照。二重管理防止＝SIDEBAR_WIDTH_PX参照） */}
      <div className="flex-1 min-w-0 overflow-hidden" style={{ marginLeft: SIDEBAR_WIDTH_PX }}>
        <Header />
        <main className="p-6">
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </main>
      </div>
    </div>
  );
}

